import React from 'react';
import { motion } from 'framer-motion';
import './animated-bubbles.scss';

const AnimatedBubbles = () => {
  const bubbles = Array.from({ length: 20 }, (_, i) => ({
    id: i,
    size: Math.random() * 100 + 20, // 20px to 120px
    delay: Math.random() * 5,
    duration: Math.random() * 20 + 10, // 10s to 30s
    x: Math.random() * 100, // 0% to 100%
    y: Math.random() * 100, // 0% to 100%
    opacity: Math.random() * 0.3 + 0.1 // 0.1 to 0.4
  }));

  return (
    <div className="animated-bubbles">
      {bubbles.map((bubble) => (
        <motion.div
          key={bubble.id}
          className="bubble"
          style={{
            left: `${bubble.x}%`,
            top: `${bubble.y}%`,
            width: `${bubble.size}px`,
            height: `${bubble.size}px`,
            opacity: bubble.opacity
          }}
          initial={{ 
            scale: 0,
            y: 0
          }}
          animate={{
            scale: [0, 1, 1.2, 1],
            y: [0, -100, -200, -300],
            x: [0, Math.random() * 20 - 10, Math.random() * 30 - 15, Math.random() * 40 - 20]
          }}
          transition={{
            duration: bubble.duration,
            repeat: Infinity,
            delay: bubble.delay,
            ease: "easeInOut"
          }}
          whileHover={{
            scale: 1.5,
            opacity: 0.8,
            transition: { duration: 0.3 }
          }}
        />
      ))}
    </div>
  );
};

export default AnimatedBubbles;
